import { Dashboard } from 'models/dashboard';
import { UserFromFaweb } from 'models/userFromFaweb';
import { api } from './client';

export async function getDashboard(dashboardId: string): Promise<Dashboard> {
    const response = await api.get(`/api/dashboards/${dashboardId}`);
    return response.data;
}

export async function updateDashboard(dashboardId: string, changes: Partial<Dashboard>): Promise<Dashboard> {
    const response = await api.patch(`/api/dashboards/${dashboardId}`, changes);
    return response.data;
}

export async function createDashboard(dashboard: Partial<Dashboard>): Promise<Dashboard> {
    const { data: newDashboard } = await api.post('/api/dashboards', dashboard);
    return newDashboard;
}

export async function getAllDashboards(): Promise<Dashboard[]> {
    const response = await api.get('/api/dashboards');
    return response.data.dashboards;
}

export async function getDashboardUsers(dashboardId: string): Promise<UserFromFaweb[]> {
    const response = await api.get(`/api/dashboards/${dashboardId}/users`);
    return response.data.users;
}
